'use strict';
var $ = require('../internals/export');
var log10 = require('../internals/math-log10');

// `Math.log10` method
// https://tc39.es/ecma262/#sec-math.log10
$({ target: 'Math', stat: true }, {
  log10: log10
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.math.log10.js
// module id = 443
// module chunks = 0